/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PackageSelectItemDto } from '../../models/package-select-item-dto';

export interface GetPackageSelectItemsFromSortiment$Params {
  subType: string;
}

export function getPackageSelectItemsFromSortiment(http: HttpClient, rootUrl: string, params: GetPackageSelectItemsFromSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PackageSelectItemDto>>> {
  const rb = new RequestBuilder(rootUrl, getPackageSelectItemsFromSortiment.PATH, 'get');
  if (params) {
    rb.query('subType', params.subType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PackageSelectItemDto>>;
    })
  );
}

getPackageSelectItemsFromSortiment.PATH = '/sortiments/packages/select-items';
